/**
 * Formats a date as relative time showing days, months, or years
 * - If less than 30 days: shows days
 * - If less than 365 days: shows months
 * - Otherwise: shows years
 * - Returns 'N/A' for invalid dates
 */
export const formatTimeSinceUpdate = (dateString: string): string => {
    const startDate = new Date(dateString)

    // Check if the date is invalid
    if (isNaN(startDate.getTime())) {
        return 'N/A'
    }

    const now = new Date()

    const diffMs = now.getTime() - startDate.getTime()
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

    // Less than 30 days: show days
    if (diffDays < 30) {
        return `${diffDays.toString()} day${diffDays !== 1 ? 's' : ''}`
    }

    // Less than 365 days: show months
    if (diffDays < 365) {
        const diffMonths = Math.floor(diffDays / 30)
        return `${diffMonths.toString()} month${diffMonths !== 1 ? 's' : ''}`
    }

    // 365 days or more: show years
    const diffYears = Math.floor(diffDays / 365)
    return `${diffYears.toString()} year${diffYears !== 1 ? 's' : ''}`
}
